module.exports = __webpack_public_path__ + "static/media/web_logo02.f3816774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/web_logo02.png
// module id = 1046
// module chunks = 12